module.exports = __webpack_public_path__ + "media/images/athletes/4171-627a7d8d6522579bca6c02450d3a7fc5.png";